const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;

const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
};

export const DROP_ZONE_CONFIG = {
  accept: ACCEPTED_FILE_TYPES,
  maxSize: MAX_FILE_SIZE,
  maxFiles: 1,
};
